import React from 'react';
import { X } from 'lucide-react';

interface ConfirmationPromptProps {
  question: string;
  actionType: string;
  onConfirm: (e: React.MouseEvent) => void;
  onDecline: (e: React.MouseEvent) => void;
  theme?: 'light' | 'dark';
}

export const ConfirmationPrompt: React.FC<ConfirmationPromptProps> = ({
  question,
  actionType,
  onConfirm,
  onDecline,
  theme = 'light'
}) => {
  return (
    <div className={`p-3 my-2 rounded-lg border relative z-10 overflow-visible ${
      theme === 'dark' 
        ? 'bg-gray-800 border-gray-700 text-gray-100' 
        : 'bg-blue-50 border-blue-200 text-gray-800'
    }`}>
      <div className="flex items-center justify-between mb-1">
        <div className="flex items-center">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className={`h-4 w-4 mr-1.5 ${theme === 'dark' ? 'text-blue-400' : 'text-blue-500'}`} 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path 
              fillRule="evenodd" 
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" 
              clipRule="evenodd" 
            />
          </svg>
          <h3 className="font-medium text-sm">Confirm Action</h3>
        </div>
        <button 
          onClick={onDecline}
          className={`p-0.5 rounded-full hover:bg-opacity-10 ${theme === 'dark' ? 'hover:bg-gray-300' : 'hover:bg-gray-700'}`}
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
      
      <p className="mb-2 ml-6 text-sm">{question}</p>
      
      <div className="flex flex-nowrap items-center gap-1.5 justify-end">
        <button
          onClick={onDecline}
          type="button"
          className={`px-2 py-1 rounded text-xs font-medium ${
            theme === 'dark' 
              ? 'bg-gray-700 hover:bg-gray-600 text-gray-200' 
              : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
          }`}
        >
          No
        </button>
        
        <button
          onClick={onConfirm}
          type="button"
          className={`px-2 py-1 rounded text-xs font-medium ${
            theme === 'dark' 
              ? 'bg-green-700 hover:bg-green-600 text-white' 
              : 'bg-green-600 hover:bg-green-700 text-white'
          }`}
        >
          Yes
        </button>
      </div>
    </div>
  );
};